module.exports = __webpack_public_path__ + "static/media/Illustration_point5.7fb901ed.svg";